import { render, staticRenderFns } from "./LongReadTarget.vue?vue&type=template&id=0ae7c882&"
import script from "./LongReadTarget.vue?vue&type=script&lang=js&"
export * from "./LongReadTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports